import classNames from 'classnames';
import React from 'react';
import icDiscount from 'assets/img/ic_ticket_discount.png';
import styles from './styles.module.scss';
import { calcPercentageRemaining, formatTimestamp } from '../../utils';
import IntervalTicker from 'src/utils/intervalTicker';

const StakingBanner = ({
  className,
  promotion,
  onFinished
}) => {
  const [remaining, setRemaining] = React.useState();
  const calcPercentRemaining = React.useCallback(() => {
    if (!promotion || !promotion.begin || !promotion.end) {
      return 0;
    }

    return calcPercentageRemaining(Date.now(), new Date(promotion.begin).getTime(), new Date(promotion.end).getTime(), promotion.rate);
  }, [promotion]);
  const [currentPercent, setCurrentPercent] = React.useState(calcPercentRemaining);

  const renderNumber = (time, label) => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.item
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.time
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.spanTime
    }, time.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false
    }))), /*#__PURE__*/React.createElement("span", {
      className: styles.labelTime
    }, label));
  };

  const renderCountdown = () => {
    if (!remaining) return null;
    const times = formatTimestamp(remaining);
    return /*#__PURE__*/React.createElement("div", {
      className: styles.container
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.spanLabel
    }, "Boosting ends in: "), /*#__PURE__*/React.createElement("div", {
      className: styles.wrapperTime
    }, renderNumber(times.days, 'Day'), renderNumber(times.hours, 'Hour'), renderNumber(times.minutes, 'Minute'), renderNumber(times.seconds, 'Second')));
  };

  React.useLayoutEffect(() => {
    if (!promotion.end) {
      return () => {};
    }

    const intervalTicket = new IntervalTicker(Date.now(), new Date(promotion.end).getTime(), timestamp => {
      setRemaining(timestamp);
      const seconds = Math.floor(timestamp / 1000) % 60;

      if (seconds % 30 === 0) {
        // set percent affer 30 seconds
        setCurrentPercent(calcPercentRemaining());
      }
    }, () => {
      setRemaining(undefined);
      onFinished && onFinished();
    });
    intervalTicket.start();
    return () => {
      intervalTicket.clear();
    };
  }, [calcPercentRemaining, onFinished, promotion.end]);

  if (!remaining) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.wrapper, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, /*#__PURE__*/React.createElement("img", {
    src: icDiscount,
    className: styles.iconDiscount
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.divTitle
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.spanPercent
  }, `${currentPercent.toLocaleString('en-US', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
    useGrouping: false
  })}%`), "\xA0", /*#__PURE__*/React.createElement("span", {
    className: styles.spanTxt
  }, "Private Ticket Boosting")), /*#__PURE__*/React.createElement("div", {
    className: styles.icInfo
  })), renderCountdown()));
};

export default StakingBanner;